const { REACT_APP_CONNECTION_INFO_BASE_URL } = process.env;

/**
 * Is this dashboard/report name free? POST /check-dashboard-duplicate.
 *
 * Taken = the user already has a board by that name, or a Global board does
 * (case-insensitive). `id` is the board being renamed, so its own name is not a
 * clash. Same contract as /check-group-duplicate: the API answers 409 for a
 * duplicate, so the body is read whatever the status.
 *
 * @returns {Promise<{ isDuplicate: boolean, message: string }>}
 * @throws when the check itself could not be made — callers treat that as
 *         "unknown", not as "taken".
 */
export async function checkDashboardDuplicate(name, id) {
  const response = await fetch(`${REACT_APP_CONNECTION_INFO_BASE_URL}/check-dashboard-duplicate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
    body: JSON.stringify({ name: String(name || "").trim(), id: id || null }),
  });
  const data = await response.json();
  if (typeof data?.isDuplicate !== "boolean") {
    throw new Error(data?.message || `Name check failed (${response.status})`);
  }
  return { isDuplicate: data.isDuplicate, message: data.message || "" };
}
